import OrderList from '../Order';

/** Admin Temporary Orders — unpaid/online hold orders (isTempOrder=true). */
const TempOrder = () => <OrderList tempOrdersOnly />;

export default TempOrder;
